export const REMOTE_CONFIG_KEYS = {
  MAINTENANCE_MODE: 'maintenance_mode',
  FEATURE_FLAGS: 'feature_flags',
  RECAPTCHA_CONFIGS: 'recaptcha_configs',
  TERMS_POLICY_CONTENT: 'terms_policy_content'
};
